import React from 'react';
import Button, { ButtonThemes } from '../button/Button';
import Alert from '../alert/Alert';
import styles from './ObsoleteNotice.module.scss';

interface Props {
    message: string;
    buttonLabel: string;
    onClick: () => void;
}

export const ObsoleteNotice: React.FC<Props> = ({ message, buttonLabel, onClick }) => {
    return (
        <div className={styles.container}>
            <Alert type='info'>
                <div className={styles.inline}>
                    <span className={styles.message}>{message}</span>
                    <span className={styles.ctaWrapper}>
                        <Button
                            className={styles.cta}
                            label={buttonLabel}
                            theme={ButtonThemes.textPrimary}
                            onClick={onClick}
                        />
                    </span>
                </div>
            </Alert>
        </div>
    );
};
